import React, { ReactNode } from "react";
import Box from "@mui/material/Box";
import Header from "./header/Header";
import Main from "./main/Main";
import Footer from "./footer/Footer";

const TOP_BANNER_HEIGHT = 32; // px
const NAVBAR_HEIGHT_XS = 76; // px (matches xs minHeight in NavBar)
const NAVBAR_HEIGHT_MD = 80; // px (matches md minHeight in NavBar)
const CATEGORY_BAR_HEIGHT = 48; // px (estimated height for CategoryLinksBar)

type Props = {
  children: ReactNode;
};

const Layout: React.FC<Props> = ({ children }) => {
  return (
    <>
      <Header />
      <Box
        sx={{
          pt: {
            xs: `${TOP_BANNER_HEIGHT + NAVBAR_HEIGHT_XS - 6}px`, // Reduced by 6px
            md: `${
              TOP_BANNER_HEIGHT + NAVBAR_HEIGHT_MD + CATEGORY_BAR_HEIGHT - 6
            }px`, // Reduced by 6px
          },
        }}
      >
        <Main>{children}</Main>
        <Footer />
      </Box>
    </>
  );
};

export default Layout;
